import React from 'react'
import styled from 'styled-components'

import { TimeAgo, TableComponents } from '@sketch/components'
import { ReactComponent as FolderIcon } from '@sketch/icons/folder-closed-16'

import {
  ImageWrapper,
  TableWrapper,
  Name,
  TableCell,
  NameWrapper,
} from '../DocumentItem/DocumentItem.styles'
import { ProjectItemProps, getButtonProps, renderDropdown } from './utils'
import { handleTimeFormat } from '../DocumentItem'
import { StyledStatusIcon } from './ProjectItem.styles'

export const ProjectItemListView = styled(function ProjectItemListView(
  props: ProjectItemProps
) {
  const { className, name, deletedAt, renderDropdownItems, onClick } = props

  const dropdownContent = renderDropdownItems?.()

  const a11yProps = onClick ? getButtonProps(onClick) : {}

  return (
    <TableWrapper className={className} title={name} {...a11yProps}>
      <TableCell>
        <NameWrapper>
          <ImageWrapper title={name}>
            <StyledStatusIcon as={FolderIcon} aria-label={`Project ${name}`} />
          </ImageWrapper>
          <Name>{name}</Name>
        </NameWrapper>
      </TableCell>
      <TableCell>{'—'}</TableCell>
      <TableCell>
        <div className="keep-size">
          {deletedAt ? (
            <TimeAgo date={deletedAt} formatter={handleTimeFormat} />
          ) : (
            '—'
          )}
        </div>
      </TableCell>
      <TableCell>{'—'}</TableCell>
      {dropdownContent && (
        <TableComponents.TableCellSticky>
          {renderDropdown(dropdownContent, props.deletedAt)}
        </TableComponents.TableCellSticky>
      )}
    </TableWrapper>
  )
})``
